import React from "react"
export default function PlaceContainerElement(props){
    return(
        <div className="placeContainerElement" onClick={props.function} id={props.id}>
            <div className="imgContainer"><img src={props.imgUrl} style={{objectFit:"contain",height:"100%",width:"100%"}}></img></div>
            <div>{props.placeName}</div>
        </div>
    )
}